module.exports = __webpack_public_path__ + "static/ai_competence_gray-931ddc007f8c43da24252b3857646331.png";